import React from 'react';
import {view, Icon, SelectFieldItem, tokens} from '@sail/ui';
import {info} from '@sail/icons/react/Icon';
import type {IconAsset} from '@sail/icons/types';
import {Text} from './Text';

const DISABLED_COLOR = tokens.color.neutral[400].toString();

interface SelectFieldItemWithTooltipProps {
  id: string;
  label: string;
  isDisabled: boolean;
  disabledTooltip?: string;
  iconElement?: IconAsset;
}

export const SelectFieldItemWithTooltip: React.FC<
  SelectFieldItemWithTooltipProps
> = ({id, label, isDisabled, disabledTooltip, iconElement}) => {
  const tooltipContent = isDisabled ? disabledTooltip : undefined;

  return (
    <SelectFieldItem key={id} id={id} aria-label={tooltipContent || label}>
      <view.div css={{display: 'contents'}} title={tooltipContent}>
        {iconElement ? (
          <Icon
            icon={iconElement}
            size="medium"
            css={{
              borderRadius: 'xsmall',
              color: isDisabled ? DISABLED_COLOR : 'text',
              marginRight: 'small',
              order: -1,
              flexShrink: 0,
            }}
          />
        ) : null}
        <Text
          type="body"
          css={{
            color: isDisabled ? DISABLED_COLOR : 'text',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            order: 0,
          }}
        >
          {label}
        </Text>
        {isDisabled ? (
          <Icon
            icon={info}
            size="xsmall"
            css={{
              color: DISABLED_COLOR,
              flex: 'none',
              order: 2,
              flexGrow: 0,
            }}
          />
        ) : null}
      </view.div>
    </SelectFieldItem>
  );
};
